<template>
  <section class="relative bg-[#039B75] py-24 lg:py-32 mb-12">
    <div class="container mx-auto px-4 text-center">
      <p class="text-white text-sm md:text-base font-semibold tracking-widest uppercase mb-4">
        Faça um curso online
      </p>
      <h2 class="text-white text-3xl md:text-4xl lg:text-5xl font-bold mb-8 max-w-3xl mx-auto uppercase leading-14">
        Melhore suas habilidades com os cursos do +IFMG
      </h2>
      <UButton color="primary" variant="outline" size="lg" @click="openModalRegister"
        class="rounded-full px-14 py-3 border-2 hover:border-transparent hover:bg-[#2441e7] hover:cursor-pointer text-white text-sm transition-all">
        Começe Agora
      </UButton>
    </div>
  </section>
</template>
<script setup lang="ts">
const uiStore = useUiStore()
const userStore = useUserStore()
const router = useRouter()

const openModalRegister = () => {
  if (userStore.isLoggedIn) {
    uiStore.isAuthModalOpen = false
    navigateTo(`/categoria/`)
  } else {
    router.replace({ hash: `#register` })
    uiStore.isAuthModalOpen = true
  }
}
</script>